"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TabContentMatch;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactIntl = require("react-intl");

var _TabContentMatchModule = _interopRequireDefault(require("./TabContentMatch.module.scss"));

var _TabContentMatch = _interopRequireDefault(require("./TabContentMatch.i18n"));

var _assets = require("../../../../../../assets");

var _ColorizedImage = _interopRequireDefault(require("../../../../../common/ColorizedImage/ColorizedImage"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TabContentMatch(_ref) {
  var dominatingGuild = _ref.dominatingGuild,
      challengingGuild = _ref.challengingGuild,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_TabContentMatchModule.default.content, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _TabContentMatchModule.default.guildLabel
  }, formatMessage(_TabContentMatch.default.guild)), /*#__PURE__*/_react.default.createElement("div", {
    className: _TabContentMatchModule.default.status
  }, formatMessage(_TabContentMatch.default.occupied)), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_TabContentMatchModule.default.guild, _TabContentMatchModule.default.dominating)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_TabContentMatchModule.default.colorIcon, _TabContentMatchModule.default.blue)
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _TabContentMatchModule.default.mark,
    style: {
      backgroundColor: dominatingGuild === null || dominatingGuild === void 0 ? void 0 : dominatingGuild.cloakColor
    }
  }, dominatingGuild && /*#__PURE__*/_react.default.createElement(_ColorizedImage.default, {
    imgSrc: "".concat(_assets.ASSETS_GUILD_MARKS, "/").concat(dominatingGuild.iconFileName),
    color: dominatingGuild.iconColor
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _TabContentMatchModule.default.name
  }, dominatingGuild === null || dominatingGuild === void 0 ? void 0 : dominatingGuild.name), /*#__PURE__*/_react.default.createElement("div", {
    className: _TabContentMatchModule.default.points
  }, dominatingGuild && formatMessage(_TabContentMatch.default.owner)
  /* TODO: show points instead if inProgress */
  )), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_TabContentMatchModule.default.guild, _TabContentMatchModule.default.challenging)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_TabContentMatchModule.default.colorIcon, _TabContentMatchModule.default.red)
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _TabContentMatchModule.default.mark,
    style: {
      backgroundColor: challengingGuild === null || challengingGuild === void 0 ? void 0 : challengingGuild.cloakColor
    }
  }, challengingGuild && /*#__PURE__*/_react.default.createElement(_ColorizedImage.default, {
    imgSrc: "".concat(_assets.ASSETS_GUILD_MARKS, "/").concat(challengingGuild.iconFileName),
    color: challengingGuild.iconColor
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _TabContentMatchModule.default.name
  }, challengingGuild === null || challengingGuild === void 0 ? void 0 : challengingGuild.name), /*#__PURE__*/_react.default.createElement("div", {
    className: _TabContentMatchModule.default.points
  }, challengingGuild && formatMessage(_TabContentMatch.default.challenger)
  /* TODO: show points instead if inProgress */
  )), /*#__PURE__*/_react.default.createElement("div", {
    className: _TabContentMatchModule.default.remainingTime
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _TabContentMatchModule.default.label
  }, formatMessage(_TabContentMatch.default.battleTimeRemaining)), /*#__PURE__*/_react.default.createElement("div", {
    className: _TabContentMatchModule.default.value
  }, formatMessage(_TabContentMatch.default.battleNotEngaged))), /*#__PURE__*/_react.default.createElement("div", {
    className: _TabContentMatchModule.default.nextBattle
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _TabContentMatchModule.default.label
  }, formatMessage(_TabContentMatch.default.nextTimeOfBattle)), /*#__PURE__*/_react.default.createElement("div", {
    className: _TabContentMatchModule.default.value
  }, formatMessage(_TabContentMatch.default.noBattleIsSheduled))));
}